import { APIConnector, Settings } from "../base";

const apiConnector = new APIConnector({ timeout: 40000 });

export default class LocationConfig {
	static get base() {
		return Settings.server + "/provinces";
	}
	static get endpointGetProvinces() {
		return `${LocationConfig.base}/getProvinces`;
	}

	static get endpointGetCitiesOfProvince() {
		return `${LocationConfig.base}/getCitiesofProvice/`;
	}

	static get APIConnector() {
		return apiConnector;
	}
}



// WEBPACK FOOTER //
// ./src/provider/Location/LocationConfig.js